// import { computeHeadingLevel } from '@testing-library/react';
import React, {Component} from "react";
import axios from "axios";
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import {setCountryJson} from "../../actions/actions";
import JSONEditor from "jsoneditor";
import "jsoneditor/dist/jsoneditor.css";
import "./JsonEditor.css";
import Translate from "react-translate-component";
import en from "../langs/en";
import ar from "../langs/ar";
import counterpart from "counterpart";
counterpart.registerTranslations("en", en);
counterpart.registerTranslations("ar", ar);
// Variable for store the updated json and us it for send the json to api
let updatedJson = {};
let countryIdFromUrl = "";
let mainTitle = <Translate content="addCountry.title" />;
let countryName = "";
let countryNameFromUrl = "";
let objFromUrl;
let countryId;
class Jsoneditor extends Component {
  constructor(props) {
    super(props);
    countryNameFromUrl = "";
    console.log(this.props);
    countryId = this.props.countryId;
    this.showJsonFromUrl();
  }
  componentDidMount() {
    const options = {
      mode: "tree",
    };

    // To check if the user open edit tool or add country tool
    if (this.props.updatedJson) {
      console.log("update", this.props.updatedJson);
      this.jsoneditor = new JSONEditor(this.container, options);
      this.jsoneditor.set(this.props.updatedJson);
    } else if (window.location.hash.includes("editCountry")) {
      console.log("update from Url", objFromUrl);
      this.jsoneditor = new JSONEditor(this.container, options);
    } else {
      console.log("default");
      this.jsoneditor = new JSONEditor(this.container, options);
      // Set default Json Editor's object
      const URL = `https://follow.leafwaysco.com/tradegate/apis/country_get.php?country_id=4`;
      axios.get(URL).then((res) => {
        let defaultJson = res.data;

        this.jsoneditor.set(defaultJson);
      });
    }
  }
  showJsonFromUrl = () => {
    if (window.location.hash.includes("editCountry")) {
      // Get country name frm the url and parse it to capitalize as the name of country in All countrys json
      let url = window.location.hash;
      let n = url.indexOf("editCountry/");
      let res = url.substr(n + 12, url.length - 1);
      let editNameFromUrl = res.charAt(0).toUpperCase() + res.slice(1);
      console.log(editNameFromUrl);
      // update edit tool Title to  ===> edit country: "country name"
      countryNameFromUrl = editNameFromUrl;
      // Countries Names URL
      const countriesURL =
        "https://follow.leafwaysco.com/tradegate/apis/country_all.php";
      axios.get(countriesURL).then((res) => {
        let data = res.data;
        for (let i = 0; i < data.length; i++) {
          //   debugger;
          if (data[i].name === editNameFromUrl) {
            countryIdFromUrl = data[i].id;
            this.getCountryJSONFromUrl(countryIdFromUrl, editNameFromUrl);
          }
        }
      });
    }
  };
  getCountryJSONFromUrl = (id, name) => {
    // Countries data json URL
    // const URL = "https://run.mocky.io/v3/8af3b885-d01f-4c74-bfb2-3c20fdbf3ba1";
    const URL = `https://follow.leafwaysco.com/tradegate/apis/country_get.php?country_id=${id}`;
    axios.get(URL).then((res) => {
      objFromUrl = res.data;
      console.log(name);
      // Set Json Editor's object
      this.jsoneditor.set(objFromUrl);
    });
  };
  componentWillUnmount() {
    if (this.jsoneditor) {
      this.jsoneditor.destroy();
    }
  }
  // get json from editor and pass it to "sendJSONInRequest" function
  getJSON = () => {
    let getUpdatedJson = this.jsoneditor.get();
    updatedJson = getUpdatedJson;
  };
  componentDidUpdate() {
    this.jsoneditor.update(this.props.json.json);
  }
  // Should take the new JSOn and send it to the API and check
  // if the json exist before it will updated
  // if the json doen't exist it will be added to the API
  sendJSONInRequest = (countryId) => {
    this.getJSON();
    console.log(updatedJson);
    // URL for testing
    const URL = `https://follow.leafwaysco.com/tradegate/apis/country_edit.php?country_id=${countryId}`;
    axios.post(URL, updatedJson).then((res) => {
      console.log(URL);
      console.log(res.data);
    });
    // To reset the editor value and make the title above to "Add Country"
    // this.props.setCountryJson({}, "Add", "");
  };
  render() {
    // To switch title from Arabic to English
    // debugger;
    if (this.props.updatedJson) {
      countryName = ": " + this.props.json.updatedCountry;
      mainTitle = <Translate content="editCountry.title" />;
    } else if (countryNameFromUrl !== "") {
      countryName = ": " + countryNameFromUrl;
      mainTitle = <Translate content="editCountry.title" />;
    } else {
      countryName = "";
      mainTitle = <Translate content="addCountry.title" />;
    }
    let json = this.props.json.json;
    return (
      <div className="container">
        <div className="addCountry-container">
          <h2>
            {mainTitle} {countryName}
          </h2>

          <div
            id="jsoneditor"
            className="jsoneditor-react-container"
            ref={(elem) => (this.container = elem)}
          ></div>
          <Link
            to="/allCountries"
            className="json-save-btn"
            onClick={() => this.sendJSONInRequest(countryId)}
          >
            Save JSON
          </Link>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    json: state,
  };
}
export default connect(mapStateToProps, {setCountryJson})(Jsoneditor);
